export class ScheduleDate {
  private date: Date;

  constructor(date: Date) {
    this.date = new Date(date);
  }

  static fromDateAndTime(dateString: string, timeString: string): ScheduleDate {
    const [year, month, day] = dateString.split('-').map(Number);
    const [h, m, s = 0] = timeString.split(':').map(Number);
    const date = new Date(year, month - 1, day, h, m, s);
    return new ScheduleDate(date);
  }

  toISOStringDate(): string {
    return this.date.toISOString().split('T')[0];
  }

  toTimeString(): string {
    return this.date.toTimeString().slice(0, 8);
  }

  getRaw(): Date {
    return this.date;
  }

  isAfterNow(): boolean {
    return this.date.getTime() > Date.now();
  }

  withTime(timeString: string): ScheduleDate {
    const [h, m, s = 0] = timeString.split(':').map(Number);
    const updated = new Date(this.date);
    updated.setHours(h, m, s, 0);
    return new ScheduleDate(updated);
  }

  withDate(dateString: string): ScheduleDate {
    const [y, m, d] = dateString.split('-').map(Number);
    const updated = new Date(this.date);
    updated.setFullYear(y, m - 1, d);
    return new ScheduleDate(updated);
  }
}
